import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { Badge, Collapse } from 'reactstrap'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from '../../src/store/actions/actions'
import SidebarRun from './Sidebar.run'
import Menu from './Menu'
import { IAppState } from '../../src/store/state.interface.web'

/** Component to display headings on sidebar */
const SidebarItemHeader = ({ item }: any) => (
  <li className="nav-heading">
    <span>{item.heading}</span>
  </li>
)

/** Normal items for the sidebar */
const SidebarItem = ({ item, isActive }: any) => {
  return <li className={isActive ? 'active' : ''}>
    <Link to={item.path} title={item.name}>
      {item.label && <Badge tag="div" className="float-right" color={item.label.color}>{item.label.value}</Badge>}
      {item.icon && <em className={item.icon} />}
      <span>{item.name}</span>
    </Link>
  </li>
}

/** Build a sub menu with items inside and attach collapse behavior */

const SidebarSubItem = ({ item, isActive, handler, children, isOpen }: any) => (
  <li className={isActive ? '' : ''}>
    <div className="nav-item" onClick={handler}>
      {item.label && <Badge tag="div" className="float-right" color={item.label.color}>{item.label.value}</Badge>}
      {item.icon && <em className={item.icon} />}
      <span>{item.name}</span>
    </div>
    <Collapse isOpen={isOpen}>
      <ul id={item.path} className="sidebar-nav sidebar-subnav">
        {children}
      </ul>
    </Collapse>
  </li>
)

/** Component used to display a header on menu when using collapsed/hover mode */
const SidebarSubHeader = ({ item }: any) => (
  <li className="sidebar-subnav-header">{item.name}</li>
)

class Sidebar extends Component<any, any> {
  state = {
    collapse: {}
  }

  componentDidMount() {
    // pass navigator to access router api
    SidebarRun(this.navigator, this.closeSidebar)
    // prepare the flags to handle menu collapsed states
    this.buildCollapseList()

    // Listen for routes changes in order to hide the sidebar on mobile
    this.props.history.listen(this.closeSidebar)
  }

  closeSidebar = () => {
    this.props.actions.toggleSetting('asideToggled')
  }

  /** prepare initial state of collapse menus. Doesnt allow same route names */
  buildCollapseList = () => {
    const collapse = {}
    Menu
      .filter(({ heading }) => !heading)
      .forEach(({ name, path, submenu }) => {
        // @ts-ignore
        collapse[name] = this.routeActive(submenu ? submenu.map(({ path }) => path) : path)
      })
    this.setState({ collapse })
  }

  navigator = (route: { replace: (arg0: string, arg1: string) => void; }) => {
    this.props.history.push(route.replace('#', '')) // remove '#' in case of use HashRouter
  }

  routeActive(paths: any) {
    paths = Array.isArray(paths) ? paths : [paths]
    return paths.some((p: any) => {
      return( this.props.location.pathname.indexOf(p) > -1)})
  }

  toggleItemCollapse(stateName: string) {
    for (const c in this.state.collapse) {
      if (this.state.collapse[c] === true && c !== stateName) {
        this.setState({
          collapse: {
            [c]: false
          }
        })
      }
    }
    this.setState({
      collapse: {
        [stateName]: !this.state.collapse[stateName]
      }
    })
  }

  getSubRoutes: (item: any) => any[] = (item: any) => item.submenu.map(({ path }: any) => path)

  /** map menu config to string to determine which element to render */
  itemType = (item: { heading: any; submenu: any; }) => {
    if (item.heading) { return 'heading' }
    if (!item.submenu) { return 'menu' }
    if (item.submenu) { return 'submenu' }
  }
// const {isSuperUser, isAdmin} = this.props
 hasAccess = (permissions: any) => {
    if (permissions.suAccess && this.props.isSuperUser) {
      return true
    } else if (permissions.adminAccess && this.props.isAdmin) {
      return true
    } else if (permissions.userAccess && !this.props.isAdmin) {
      return true
    } else {
      return (false)
    }
  }

render() {
  const { isSuperUser, isAdmin, practiceId, userId } = this.props
  const filteredMenu = Menu.filter(({ permissions }: any) => {
    if (isSuperUser) {
      return permissions.suAccess
    }
    if (isAdmin) {
      return permissions.adminAccess
    }
    return userId ? permissions.userAccess : false
  })
  return (
      <aside className="aside-container">
        { /* START Sidebar (left) */}
        <div style={{ overflow: 'hidden' }}>
          <nav data-sidebar-anyclick-close="" className="sidebar">
            { /* START sidebar nav */}
            <ul className="sidebar-nav">
              {
                filteredMenu.map((item: any, i) => {
                  if (item.isPracticeDetail && !item.permissions.suAccess) {
                      item.path = `/practices/${practiceId}`
                  }
                  // heading
                  if (this.itemType(item) === 'heading') {
                    return (
                      <SidebarItemHeader item={item} key={i} />
                    )
                  } else {
                    if (this.itemType(item) === 'menu'
                      &&
                      (this.hasAccess(item.permissions))
                    ) {
                        return (
                          <SidebarItem isActive={this.routeActive(item.path)} item={item} key={i} />
                        )
                      }
                    if (this.itemType(item) === 'submenu') {
                          return [<SidebarSubItem item={item} isOpen={this.state.collapse[item.name]}
                            handler={this.toggleItemCollapse.bind(this, item.name)}
                            isActive={this.routeActive(this.getSubRoutes(item))} key={i}>
                            <SidebarSubHeader item={item} key={i} />
                            {
                              item.submenu.map((subitem: any, i: number) =>
                                <SidebarItem key={i} item={subitem} isActive={this.routeActive(subitem.path)} />
                              )
                            }
                          </SidebarSubItem>
                          ]
                    }
                  }
                  return null // unrecognized item
                })
              }
            </ul>
            { /* END sidebar nav */}
          </nav>
        </div>
        { /* END Sidebar (left) */}
      </aside>
    )
  }
}

const mapStateToProps = (state: IAppState) => ({
  settings: state.settings,
  isSuperUser: state.login.user.isSuperUser,
  isAdmin: state.login.user.isAdmin,
  practiceId: state.login.user.orgId,
  userId: state.login.user.id
})
// @ts-ignore
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Sidebar))
